class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.initTermsModal();
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.refreshTermsModalBindings();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initTermsModal() {
    this.termsModal = document.getElementById('cart-terms-modal');
    if (!this.termsModal) return;

    this.termsDialog = this.termsModal.querySelector('.cart-terms-modal__dialog');
    this.termsCheckbox = this.termsModal.querySelector('#cart-terms-checkbox');
    this.termsSubmit = this.termsModal.querySelector('[data-cart-terms-submit]');
    this.handleTermsTrigger = this.openTermsModal.bind(this);

    this.termsCloseButtons = this.termsModal.querySelectorAll('[data-cart-terms-close]');
    this.termsCloseButtons.forEach((button) => {
      button.addEventListener('click', () => this.closeTermsModal());
    });

    this.termsKeyHandler = (event) => {
      if (event.code === 'Escape' && this.termsModal.classList.contains('is-active')) {
        this.closeTermsModal();
      }
    };
    document.addEventListener('keyup', this.termsKeyHandler);

    if (this.termsCheckbox && this.termsSubmit) {
      this.termsCheckbox.addEventListener('change', () => {
        this.termsSubmit.disabled = !this.termsCheckbox.checked;
      });
    }

    if (this.termsSubmit) {
      this.termsSubmit.addEventListener('click', () => this.submitCheckout());
    }

    this.refreshTermsModalBindings();
  }

  refreshTermsModalBindings() {
    if (!this.termsModal) return;

    if (this.checkoutTrigger) {
      this.checkoutTrigger.removeEventListener('click', this.handleTermsTrigger);
    }

    this.checkoutTrigger = document.querySelector('[data-cart-terms-trigger]');
    this.checkoutForm = document.getElementById('cart-notification-form');

    if (this.checkoutTrigger) {
      this.checkoutTrigger.addEventListener('click', this.handleTermsTrigger);
    }
  }

  openTermsModal(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (!this.termsModal) return;

    this.previousActiveElement = document.activeElement;
    this.termsModal.removeAttribute('hidden');
    this.termsModal.classList.add('is-active');
    document.body.classList.add('cart-terms-open');
    if (this.termsCheckbox) {
      this.termsCheckbox.checked = false;
    }
    if (this.termsSubmit) {
      this.termsSubmit.disabled = true;
    }

    if (this.termsDialog) {
      this.termsDialog.focus();
      trapFocus(this.termsDialog);
    }
  }

  closeTermsModal() {
    if (!this.termsModal) return;

    this.termsModal.classList.remove('is-active');
    this.termsModal.setAttribute('hidden', 'hidden');
    document.body.classList.remove('cart-terms-open');
    if (this.termsDialog) {
      removeTrapFocus(this.termsDialog);
    }
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }

  submitCheckout() {
    this.closeTermsModal();
    if (typeof this.pendingAction === 'function') {
      const action = this.pendingAction;
      this.pendingAction = null;
      action();
      return;
    }
    window.location.href = '/checkout';
  }
}

customElements.define('cart-notification', CartNotification);
